import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import { handleAddModifyOperation, fetchTableData } from '../../../../Api/ApiMethods';

const DistrictDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedDistrict, refreshData }) => {
    const initialDistrictData = {
        id: '',
        title: '',
        city: [] // Boş array olarak başlatalım
    };

    const [districtData, setDistrictData] = useState(initialDistrictData);
    const [errors, setErrors] = useState({});
    const [cities, setCities] = useState([]);
    const cityApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/city';

    // Modal açıldığında verileri ayarlamak için
    useEffect(() => {
        if (isOpen) {
            // Şehirleri getir
            fetchTableData({
                apiEndpoint: cityApiUrl,
                page: 1,
                pageSize: 100, // Tüm şehirleri almak için büyük bir sayı kullanıyoruz
                search: '',
                // Şehir verilerini state'e ata
                setDataCallback: (data) => {
                    // API'den gelen data yapısını kontrol et
                    if (data && Array.isArray(data)) {
                         setCities(data);
                    } else if (data && data.items && Array.isArray(data.items)) {
                         setCities(data.items); // Eğer data.items içindeyse
                    } else {
                         setCities([]); // Hata durumunda veya beklenmedik formatta boş array ata
                         console.error("Beklenmedik şehir verisi formatı:", data);
                         toast.error("Şehirler yüklenemedi.");
                    }
                },
                setTotalRowsCallback: () => {} // Toplam satır sayısına ihtiyacımız yok
             }).catch(error => {
                 console.error("Şehirler getirilirken hata:", error);
                 toast.error("Şehirler yüklenirken bir hata oluştu.");
                 setCities([]); // Hata durumunda boş array ata
             });


            // Eğer düzenleme modundaysak, mevcut ilçe verilerini kopyala
            if (mode === 'modify' && selectedDistrict) {
                // Eğer city bir obje ise, ID'sini array içine al
                let cityArray = [];
                if (selectedDistrict.city) {
                    // API'den city objesi {id, title, ...} şeklinde geliyorsa
                    if (typeof selectedDistrict.city === 'object' && selectedDistrict.city !== null && selectedDistrict.city.id) {
                        cityArray = [selectedDistrict.city.id];
                    // API'den city sadece ID (string/number) olarak geliyorsa
                    } else if (typeof selectedDistrict.city === 'string' || typeof selectedDistrict.city === 'number') {
                         cityArray = [selectedDistrict.city];
                    // API'den city zaten ID array'i olarak geliyorsa
                    } else if (Array.isArray(selectedDistrict.city) && selectedDistrict.city.length > 0) {
                         // İlk elemanı alalım (varsayım: tek şehir)
                         cityArray = [selectedDistrict.city[0]];
                    }
                }


                setDistrictData({
                    ...initialDistrictData,
                    ...selectedDistrict,
                    title: selectedDistrict.title || '', // Title null/undefined ise boş string ata
                    city: cityArray // ID'yi array olarak ayarla
                });
            } else {
                // Ekleme modunda ise formu sıfırla
                resetForm();
            }
        }
    }, [isOpen, mode, selectedDistrict, cityApiUrl]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let processedValue = value;

        // Büyük harfe çevrilecek alanlar
        const fieldsToUppercase = ['title'];

        // Eğer alan listedeyse VE değer bir string ise Türkçe'ye özgü büyük harfe çevir
        if (fieldsToUppercase.includes(name) && typeof value === 'string') {
            processedValue = value.toLocaleUpperCase('tr-TR');
        }

        setDistrictData({ ...districtData, [name]: processedValue }); // State'i güncelle

        // Hata varsa temizle
        if (errors[name]) {
             setErrors({ ...errors, [name]: '' });
        }
    };


    const handleCityChange = (e) => {
        const cityId = e.target.value;
        setDistrictData(prev => ({
            ...prev,
            city: cityId ? [cityId] : [] // ID değeri varsa array'e koy, yoksa boş array
        }));
         // Şehir hatasını temizle
        if (errors.city) {
            setErrors(prev => ({ ...prev, city: '' }));
        }
    };

    const validateForm = () => {
        const validationErrors = {};
        // Regex'i büyük/küçük harf kabul edecek şekilde bırakabiliriz (i flag)
        const titleRegex = /^[A-ZĞÜŞİÖÇa-zğüşıöç ]{3,50}$/i;

        if (!districtData.title || !districtData.title.trim()) { // trim eklendi
            validationErrors.title = 'İlçe adı zorunludur.';
        } else if (!titleRegex.test(districtData.title)) {
            validationErrors.title = 'İlçe adı sadece harf ve boşluk içerebilir minimum 3 karakter maksimum 50 karakter desteklemektedir.';
        }

        // districtData.city null veya undefined olabilir, kontrol ekle
        if (!districtData.city || districtData.city.length === 0 || !districtData.city[0]) {
            validationErrors.city = 'Şehir seçimi zorunludur.';
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const resetForm = () => {
        setDistrictData(initialDistrictData);
        setErrors({});
    };

    const handleCancel = () => {
        resetForm();
        toggle();
    };

    const handleOperation = async () => {
        if (!validateForm()) {
            toast.error("Lütfen formdaki hataları düzeltin.");
            return;
        }

        // Gönderilecek veri zaten state'de doğru formatta olmalı (title büyük harf, city array)
        const payload = {
             ...districtData, // Diğer alanları (id vs. varsa) koru
             title: districtData.title, // Zaten büyük harf
             city: districtData.city // Zaten [cityId] formatında
        };


        // API'ye gönderilen veriyi logla (debug için)
        console.log('Gönderilen veri:', payload);

        await handleAddModifyOperation({
            apiEndpoint,
            selectedItem: mode === 'modify' ? selectedDistrict : null, // Mod'a göre
            mode,
            data: payload, // Hazırlanan payload'ı gönder
            refreshDataCallback: refreshData,
            componentName: 'İlçe',
        });

        handleCancel(); // İşlem sonrası modal'ı kapat ve formu sıfırla
    };

    const getModalTitle = () => {
        return mode === 'add' ? 'İlçe Ekle' : 'İlçe Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    // Şehir select için geçerli değeri belirleyelim (null/undefined kontrolü eklendi)
    const selectedCityId = (districtData.city && districtData.city.length > 0) ? districtData.city[0] : '';

    return (
        <Modal isOpen={isOpen} toggle={handleCancel}>
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="title">İlçe Adı <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="title"
                            name="title"
                            value={districtData.title || ''}
                            onChange={handleInputChange} // Standart handler
                            invalid={!!errors.title}
                        />
                        {/* FormFeedback kullanmak daha standart */}
                         {errors.title && <div className="text-danger small mt-1">{errors.title}</div>}
                    </FormGroup>
                    <FormGroup>
                        <Label for="city">Şehir <span className="text-danger">*</span></Label>
                        <Input
                            type="select"
                            id="city"
                            name="city"
                            value={selectedCityId} // Hesaplanan değeri kullan
                            onChange={handleCityChange} // Özel city handler
                            invalid={!!errors.city}
                        >
                            <option value="">Şehir Seçiniz</option>
                            {/* cities null/undefined olabilir, kontrol ekle */}
                            {cities && cities.map(city => (
                                <option key={city.id} value={city.id}>
                                    {city.title}
                                </option>
                            ))}
                        </Input>
                         {/* FormFeedback kullanmak daha standart */}
                        {errors.city && <div className="text-danger small mt-1">{errors.city}</div>}
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                 {/* Buton stilleri güncellendi */}
                 <button className="btn btn-primary" onClick={handleOperation}>
                    {getButtonLabel()}
                </button>
                <button className="btn btn-secondary" onClick={handleCancel}>
                    İptal
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default DistrictDataModal;
